<template>
  <div class="page">
    <div class="coversheet">
      <div class="subreport-header text-center">
        Course Director's Closeout Report
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <div class="flex-fill">
            Submit as directed by the
            <i>Schedule of Course Reports and Transmittals</i> within 30 days of
            close of course.
          </div>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Dates of Course
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.Dates }}</span>
          </div>
        </div>
        <div class="col-5" />
      </div>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Wood Badge Course No.
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.CourseName }}</span>
          </div>
        </div>
        <div class="col-5" />
      </div>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Region
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.Region }}</span>
          </div>
        </div>
        <div class="col-5 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Area
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.Area }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Host Council Name
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.HostingCouncil }}</span>
          </div>
        </div>
        <div class="col-5 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Host Council No.
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.CouncilNumber }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Course Dates
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.Dates }}</span>
          </div>
        </div>
        <div class="col-5 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Location(s)
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.Header.Locations }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Number of participants: (volunteer)
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.ScouterCount.VolunteerParticipants }}</span>
          </div>
        </div>
        <div class="col-5 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            (professional)
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.ScouterCount.ProfessionalParticipants }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Number of staff members: (volunteer)
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.ScouterCount.VolunteerStaffMembers }}</span>
          </div>
        </div>
        <div class="col-5 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            (professional)
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.ScouterCount.ProfessionalStaffMembers }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex pr-0">
          <div
            class="d-inline-flex data-field"
            style="margin-left:0 !important"
          >
            <span style="padding-right: 8px;">{{
              reportInfo.ScouterCount.IncompleteTickets
            }}</span>
          </div>
          <div class="flex-fill pl-2">
            participants were not certified.
            <span
              class="pl-2"
              style="font-size:14px"
            >List their names and circumstances on a separate sheet.</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <div class="flex-fill">
            The following staff members were presented with assistant course
            director beads.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex pr-0">
          <div
            class="data-field flex-fill"
            style="margin-left:0 !important"
          >
            <span>{{ firstTimeStaff }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex pr-0">
          <div
            class="data-field flex-fill"
            style="margin-left:0 !important"
          >
            <img
              src="/static/img/spacer.png"
              height="28px"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <div class="flex-fill">
            Comments:
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex pr-0">
          <div
            class="data-field flex-fill"
            style="margin-left:0 !important"
          >
            <span>See attached.</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex pr-0">
          <div
            class="data-field flex-fill"
            style="margin-left:0 !important"
          >
            <img
              src="/static/img/spacer.png"
              height="28px"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-9 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Host Council Scout Executive signature
          </div>
          <div class="data-field flex-fill">
            <span />
          </div>
        </div>
        <div class="col-3 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Date
          </div>
          <div class="data-field flex-fill">
            <span />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-9 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Course Director Signature
          </div>
          <div class="data-field flex-fill">
            <span />
          </div>
        </div>
        <div class="col-3 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Date
          </div>
          <div class="data-field flex-fill">
            <span />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-9 d-flex pr-0">
          <div class="d-inline-flex pr-2">
            Address of Course Director
          </div>
          <div class="data-field flex-fill">
            <span>{{ reportInfo.CourseDirector.StreetAddress }}</span>
          </div>
        </div>
        <div class="col-3 pr-0" />
      </div>
      <div class="row">
        <div class="col-9 d-flex pr-0">
          <div
            class="data-field flex-fill"
            style="margin-left:0 !important"
          >
            <span>{{ reportInfo.CourseDirector.City }}
              {{ reportInfo.CourseDirector.State }}
              {{ reportInfo.CourseDirector.ZipCode }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <div class="flex-fill">
            Attachments (copies to area training chairman and national office):
          </div>
        </div>
      </div>
      <ul style="line-height: 1.4;">
        <li>Course final staff roster</li>
        <li>Course final participant roster</li>
        <li>Participants by Scouting position form</li>
        <li>
          Future staff recommendations, including infomraiton on current staff and
          promising participants
        </li>
        <li>Names and circumstances of uncertified participants, if any</li>
        <li>Comments and recommendations</li>
      </ul>
      <div class="row">
        <div class="col-12 d-flex">
          <div
            class="flex-fill"
          >
            <span style="font-weight:bold">Note:</span> If the course was operated
            below the minimum number of participants, circumstances should be
            explained on a separate page, including the name and title of the
            individual who authorized the course.
          </div>
        </div>
      </div>
      <div class="pageBreakBefore">
        <div class="row">
          <div class="col-12 d-flex">
            <div class="flex-fill">
              Course Comments & Recommendations
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex mr-2">
            <div
              class="flex-fill border border-default data-field pl-2"
              style="margin-left:0 !important;min-height:100px"
            >
              {{ reportInfo.CourseComments.CloseoutComments }}
            </div>
          </div>
        </div>
        <br>
        <div v-if="reportInfo.ScouterCount.Participants < 300">
          <div class="row">
            <div class="col-12 d-flex">
              <div class="flex-fill font-weight-bold">
                Small Course Circumstances
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-7 d-flex mr-2">
              <div class="d-inline-flex pr-2">
                Course Authorized By
              </div>
              <div class="data-field flex-fill">
                <span>{{
                  reportInfo.CourseComments.SmallCourseApprovalName
                }}</span>
              </div>
            </div>
            <div class="col-5 d-flex mr-2">
              <div class="d-inline-flex pr-2">
                Title
              </div>
              <div class="data-field flex-fill">
                <span>{{
                  reportInfo.CourseComments.SmallCourseApprovalTitle
                }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex">
              <div class="flex-fill">
                Comments
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex mr-2">
              <div
                class="flex-fill border border-default data-field pl-2"
                style="margin-left:0 !important;min-height:100px"
              >
                {{ reportInfo.CourseComments.SmallCourseApprovalComments }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReportCloseoutCoverSheet',
  props: {
    reportInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {}
  },
  computed: {
    firstTimeStaff: function () {
      let returnValue = ''
      for (let i = 0; i < this.reportInfo.FirstTimeStaffMembers.length; i++) {
        // cheating
        if (i === 0) {
          returnValue = this.reportInfo.FirstTimeStaffMembers[i].FullName
        } else {
          returnValue =
            returnValue +
            ', ' +
            this.reportInfo.FirstTimeStaffMembers[i].FullName
        }
      }
      return returnValue
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.data-field {
  border-bottom: 1px solid black;
  font-family: Courier;
  margin-left: 0.5rem !important;
}

.data-field span {
  padding-left: 8px;
}

.row {
  padding-top: 4px;
}

p {
  font-size: 14px;
}
</style>
